export default __webpack_public_path__ + "static/media/homeright.3bcfc2a4.svg";